import { gql } from '@apollo/client';

const getEmailValidationQuery = gql`
  query GetEmailValidationQuery($email: String!) {
    external {
      mailgun {
        validateEmail(input: { email: $email }) {
          address
          didYouMean
          isDisposableAddress
          isRoleAddress
          reason
          valid
        }
      }
    }
  }
`;

export default getEmailValidationQuery;
